import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiRepository } from '../../../../shared/infrastructure/api.repository';
import { Portfolio } from '../../domain/entities/portfolio.entity';
import {
  PortfolioRepositoryPort,
  PortfolioListPagedRequest,
  PortfolioListPagedResponse,
} from '../../domain/repositories/portfolio.repository.port';
import {
  PortfolioMapper,
  PortfolioApiResponse,
  PortfolioListPagedApiResponse,
} from '../mappers/portfolio.mapper';

@Injectable({ providedIn: 'root' })
export class PortfolioRepository extends ApiRepository implements PortfolioRepositoryPort {
  private readonly baseUrl = '/portfolios';

  create(name: string, description?: string): Observable<string> {
    return this.post<string, { name: string; description?: string }>(this.baseUrl, { name, description });
  }

  update(id: string, name: string, description?: string): Observable<void> {
    return this.put<void, { name: string; description?: string }>(`${this.baseUrl}/${id}`, { name, description });
  }

  remove(id: string): Observable<void> {
    return this.delete<void>(`${this.baseUrl}/${id}`);
  }

  getDetails(id: string): Observable<Portfolio> {
    return this.get<PortfolioApiResponse>(`${this.baseUrl}/${id}`).pipe(
      map((response) => PortfolioMapper.toDomain(response))
    );
  }

  getListPaged(request: PortfolioListPagedRequest): Observable<PortfolioListPagedResponse> {
    return this.post<PortfolioListPagedApiResponse, PortfolioListPagedRequest>(
      `${this.baseUrl}/GetListPaged`,
      request
    ).pipe(
      map((response) => ({
        items: PortfolioMapper.toDomainList(response.items),
        pageNumber: response.pageNumber,
        pageSize: response.pageSize,
        totalPages: response.totalPages,
        totalItemsCount: response.totalItemsCount,
        orderField: response.orderField,
        ascendingOrder: response.ascendingOrder,
      }))
    );
  }
}
